<script lang="ts">
    import Input from "../Form/Input.svelte";
    import Modal from "../Modal/Modal.svelte";
    import {resetPasswordSchema} from "../../validationsForm/resetPasswordValidation.ts";
    import {ApiCall} from "../../services/ApiCall.ts";
    import {push} from "svelte-spa-router";

    let passwordResetForm = {
        email: ''
    };

    let passwordPromise;
    let errors = {}
    async function resetPasswordFormValidation() {

        try  {
            await resetPasswordSchema.validate(passwordResetForm, {abortEarly: false});
            errors = {};
            
            passwordPromise = makeApiCall();
        }
        catch (err) {

            return errors = err.inner.reduce((acc, err) => {
                return ( { ...acc, [err.path]: err.message });
            }, {});
        }
    }

    let passwordRequestStatus:boolean = false;
    let passwordRequestError:boolean = false;
    async function makeApiCall() {

        const apiCall = new ApiCall();
        
        try{
            const content = await apiCall.postRequest('applicateur/forgot_password', passwordResetForm);

            if (content.success === false)
                errors = content.data
            else
                passwordRequestStatus = true;
        }
        catch (e) {
            passwordRequestError = true;
        }
    }

    function onCloseSuccessDemand() {
        push('/');
    }
</script>

{#await passwordPromise}
    <Modal title="Envoi de la demande" type="loader"/>
{/await}
{#if passwordRequestError}
    <div>
        <Modal title="Erreur lors de la demande de modification de mot de passe" type="error" message="La demande à échouée, veuillez réessayer.">
            <svelte:fragment slot="button">
                <button on:click={() => {passwordRequestError = false}} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}
{#if passwordRequestStatus}
    <div>
        <Modal title="Demande réussie" type="validation">
            <svelte:fragment slot="button">
                <button on:click={onCloseSuccessDemand} class="modal-close is-large" aria-label="close"></button>
            </svelte:fragment>
            <svelte:fragment slot="comment">
                <p class="has-text-centered">Vous recevrez prochainement un email de la part de Chrono Chape avec un nouveau mot de passe.</p>
            </svelte:fragment>
            <svelte:fragment slot="buttons-container">
                <button on:click={onCloseSuccessDemand} class="button-close button is-info">Fermer</button>
            </svelte:fragment>
        </Modal>
    </div>
{/if}

<h2 class="title is-2 has-text-centered mb-6">Mot de passe oublié</h2>

<form id="reset-password-form" autocomplete="on" on:submit|preventDefault={resetPasswordFormValidation}>
    <fieldset class="box pb-6">
        <legend class="label">
            <div class="fieldset-logo-container is-flex">
                <p>Demande d'un nouveau mot de passe</p>
            </div>
        </legend>
            <div class="is-flex-desktop is-flex-direction-row is-justify-content-space-between columns is-desktop">
                <div class="column is-12 is-6-desktop">
                    <Input bind:value={passwordResetForm.email} label="Email*" name="email" placeholder="Veuillez saisir votre adresse email" type="email" autocomplete="on" error={errors.email}/>
                </div>
            </div>
    </fieldset>

    <div class="field pt-3">
        <div class="control is-flex is-justify-content-center">
            <button class="button is-success" type="submit">Envoyer</button>
        </div>
    </div>
</form>